import { render, staticRenderFns } from "./PositionSize.vue?vue&type=template&id=62246d08&scoped=true"
import script from "./PositionSize.vue?vue&type=script&lang=js"
export * from "./PositionSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62246d08",
  null
  
)

export default component.exports